import { sortBy } from 'lodash';
import { CoachingFrameworkType, Program, ProgramType as ScreenProgramType } from 'screens/Programs/types';

import { tabsOrder } from './ProgramList.constants';
import { ProgramType, ProgramsByType } from './ProgramList.types';
import { PriceClassification } from '../../../apollo/account-api/types/global';

function getProgramListType(
  program: Pick<Program, 'type' | 'coachingFrameworkType' | 'priceClassification'>,
  enableExecutiveProgramCreation?: boolean
): ProgramType | undefined {
  const { type, coachingFrameworkType, priceClassification } = program;

  if (type === ScreenProgramType.INDIVIDUAL) {
    if (enableExecutiveProgramCreation && priceClassification === PriceClassification.EXECUTIVE) {
      return ProgramType.Executive;
    }
    if (coachingFrameworkType === CoachingFrameworkType.CoachhubFramework) {
      return ProgramType.IndividualCoachHubFramework;
    }
    if (coachingFrameworkType === CoachingFrameworkType.Legacy) {
      return ProgramType.IndividualHolisticFramework;
    }
  } else if (type === ScreenProgramType.COLLECTIVE) {
    return ProgramType.Collective;
  } else if (type === ScreenProgramType.STANDALONE_AI) {
    return ProgramType.StandaloneAI;
  }

  return undefined;
}

export function getProgramsByType(programs: Program[], enableExecutiveProgramCreation?: boolean): ProgramsByType {
  const sortedPrograms = sortBy(programs, (program) => -new Date(program.updatedAt).getTime());

  return sortedPrograms.reduce(
    (sortedProgramsByTypeSoFar, program) => {
      const listType = getProgramListType(program, enableExecutiveProgramCreation);

      if (listType) {
        sortedProgramsByTypeSoFar[listType].push(program);
      }

      return sortedProgramsByTypeSoFar;
    },
    {
      [ProgramType.Collective]: [],
      [ProgramType.IndividualCoachHubFramework]: [],
      [ProgramType.IndividualHolisticFramework]: [],
      [ProgramType.StandaloneAI]: [],
      [ProgramType.Executive]: [],
    } as ProgramsByType
  );
}

export function getTypesOfProgramsWithResults(programsByType: ProgramsByType): ProgramType[] {
  return Object.keys(programsByType).reduce((typesOfProgramsWithResultsSoFar, programType) => {
    const programsOfCurrentType = programsByType[programType as ProgramType];
    const currentTypeHasPrograms = programsOfCurrentType.length > 0;

    if (currentTypeHasPrograms) {
      typesOfProgramsWithResultsSoFar.push(programType as ProgramType);
    }

    return typesOfProgramsWithResultsSoFar;
  }, [] as ProgramType[]);
}

export function getSortedProgramTypes(programTypes: ProgramType[]): ProgramType[] {
  const copyOfProgramTypes = [...programTypes];

  copyOfProgramTypes.sort((programTypeA, programTypeB) => {
    return tabsOrder.indexOf(programTypeA) - tabsOrder.indexOf(programTypeB);
  });

  return copyOfProgramTypes;
}

export function getListTabTypeForProgram(
  program: Pick<Program, 'type' | 'coachingFrameworkType' | 'priceClassification'>,
  enableExecutiveProgramCreation?: boolean
): ProgramType {
  return getProgramListType(program, enableExecutiveProgramCreation) ?? ProgramType.IndividualCoachHubFramework;
}
